// src/components/Documentation/components/ParameterTable.jsx

import PlanBadge from './PlanBadge';

export default function ParameterTable({ parameters }) {
  return (
    <>
      {/* Mobile Card View */}
      <div className="md:hidden space-y-4">
        {parameters.map((param, index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <h4 className="text-base font-mono text-blue-600 font-semibold break-all">
                  {param.name}
                </h4>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-gray-600">{param.type}</span>
                  {param.required ? (
                    <span className="text-xs text-red-600 font-semibold">Required</span>
                  ) : (
                    <span className="text-xs text-gray-500">Optional</span>
                  )}
                </div>
              </div>
              {param.plan && (
                <div className="ml-2">
                  <PlanBadge plan={param.plan} size="sm" />
                </div>
              )}
            </div>

            {param.default && (
              <div className="mb-2">
                <span className="text-xs font-semibold text-gray-700">Default: </span>
                <span className="text-xs font-mono text-gray-600">{param.default}</span>
              </div>
            )}

            <p className="text-sm text-gray-700">{param.description}</p>
          </div>
        ))}
      </div>

      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase border-b">
                Parameter
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase border-b">
                Type
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase border-b">
                Required
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase border-b">
                Default
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase border-b">
                Plan
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase border-b">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {parameters.map((param, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-sm font-mono text-blue-600">
                  {param.name}
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {param.type}
                </td>
                <td className="px-4 py-3 text-sm">
                  {param.required ? (
                    <span className="text-red-600 font-semibold">Yes</span>
                  ) : (
                    <span className="text-gray-500">No</span>
                  )}
                </td>
                <td className="px-4 py-3 text-sm font-mono text-gray-600">
                  {param.default}
                </td>
                <td className="px-4 py-3 text-sm">
                  {param.plan && <PlanBadge plan={param.plan} size="sm" />}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700">
                  {param.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}